import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const S9PageSection = ui.S9PageSection.default;
const Fieldset = ui.S9Fieldset.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const AddressDetail = ({ schema }: Props) => {
  const fields = [
    {
      field: 'address_line_1',
      colSize: 12,
    },
    {
      field: 'address_line_2',
      colSize: 12,
    },
    {
      field: 'suburb',
      colSize: 8,
    },
    {
      field: 'state',
      colSize: 8,
    },
    {
      field: 'post_code',
      colSize: 8,
    },
  ];

  return (
    <S9PageSection title="Address details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default AddressDetail;
